export default "__VITE_ASSET__CBdpNbzV__"